/*
  Pretty in Pink: End of an Era collectie
  Snel toevoegen vanuit de grid, maat- en typefilter, videotegels en gratis-verzendbalk.
  Wordt geladen door de collectiepagina (sections/pip-col-grid-v2.liquid en pip-collection-grid.liquid), de homepage-rijen
  (pip-home-products.liquid), related products op de productpagina (related-products.liquid) en de videotegels
  (snippets/pip-grid-video.liquid). Een aanpassing hier raakt al die plekken (fase 2, B2-29).
*/
(function () {
  if (window.pipCollectionLoaded) return;
  window.pipCollectionLoaded = true;

  var SIZE_MAP = {
    S: ['S', 'XS', 'XS/S'],
    M: ['M', 'M/L'],
    L: ['L', 'M/L'],
    XL: ['XL', 'XL/2XL'],
    XXL: ['XXL', '2XL', 'XL/2XL'],
    '3XL': ['3XL', '4XL', '3XL/4XL']
  };
  var state = { type: 'all', size: 'all' };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ---------- Filters (maat en type) ---------- */
  function itemMatches(li) {
    var types = ' ' + (li.getAttribute('data-pip-types') || '') + ' ';
    if (state.type !== 'all' && types.indexOf(' ' + state.type + ' ') === -1) return false;
    if (state.size === 'all') return true;
    var sizes = li.getAttribute('data-pip-sizes') || '';
    if (sizes.indexOf('|ALL|') !== -1) return true;
    var wanted = SIZE_MAP[state.size] || [state.size];
    for (var i = 0; i < wanted.length; i++) {
      if (sizes.indexOf('|' + wanted[i] + '|') !== -1) return true;
    }
    return false;
  }

  function applyFilters() {
    var items = document.querySelectorAll('#product-grid > li[data-pip-types]');
    if (!items.length) return;
    var products = 0;
    items.forEach(function (li) {
      var show = itemMatches(li);
      li.hidden = !show;
      if (show && !li.classList.contains('pip-gv')) products++;
    });
    var empty = document.querySelector('[data-pip-filter-empty]');
    if (empty) empty.hidden = products > 0;
    var filtered = state.type !== 'all' || state.size !== 'all';
    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (!el.hasAttribute('data-pip-original')) el.setAttribute('data-pip-original', el.textContent.trim());
      el.textContent = filtered ? products + (products === 1 ? ' product' : ' producten') : el.getAttribute('data-pip-original');
    });
  }

  function setActive(attr, value) {
    document.querySelectorAll('[' + attr + ']').forEach(function (b) {
      var on = b.getAttribute(attr) === value;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- Snel toevoegen ---------- */
  function closePanel(scope) {
    if (!scope) return;
    var panel = scope.querySelector('[data-pip-qa-panel]');
    if (panel) panel.hidden = true;
    scope.classList.remove('is-open');
    var opener = scope.querySelector('[data-pip-qa-open]');
    if (opener) opener.setAttribute('aria-expanded', 'false');
  }

  function openPanel(scope) {
    document.querySelectorAll('[data-pip-qa].is-open').forEach(function (s) {
      if (s !== scope) closePanel(s);
    });
    var panel = scope.querySelector('[data-pip-qa-panel]');
    if (!panel) return;
    panel.hidden = false;
    scope.classList.add('is-open');
    var opener = scope.querySelector('[data-pip-qa-open]');
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }

  function flash(el) {
    el.classList.add('is-added');
    setTimeout(function () { el.classList.remove('is-added'); }, 2500);
  }

  function showError(scope, message) {
    var box = scope && scope.querySelector('[data-pip-qa-error]');
    if (!box) { window.alert(message); return; }
    box.textContent = message;
    box.hidden = false;
    setTimeout(function () { box.hidden = true; }, 4000);
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled || btn.classList.contains('is-loading')) return;
    var scope = btn.closest('[data-pip-qa]');
    btn.classList.add('is-loading');

    function ok() {
      var target = btn;
      if (scope) {
        closePanel(scope);
        target = scope.querySelector('[data-pip-qa-open]') || btn;
      }
      flash(target);
      refreshShipping();
    }
    function fail(err) {
      /* reservetekst uit Thema-instellingen > PIP collectiepagina (data-msg op de foutregel, fase 2 B2-34) */
      var msgEl = scope && scope.querySelector('[data-pip-qa-error]');
      showError(scope, (err && (err.description || err.message)) || (msgEl && msgEl.getAttribute('data-msg')) || 'Toevoegen lukte niet. Probeer het opnieuw.');
    }

    /* Fase 2, groep 10: via de openbare functie van de Section Store-winkelwagen. Die voegt toe zonder de winkelwagen
       te openen; snippets/pip-cart-toast.liquid toont dan de melding 'Toegevoegd aan winkelmandje'. */
    var ss = window.SectionStoreCart;
    if (ss && typeof ss.addItem === 'function') {
      if (window.pipCartToast) window.pipCartToast.markAdd();
      Promise.resolve(ss.addItem({ id: Number(variantId), quantity: 1 }))
        .then(ok)
        .catch(fail)
        .then(function () { btn.classList.remove('is-loading'); });
      return;
    }

    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(data);
        ok();
      })
      .catch(fail)
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  }

  /* ---------- Gratis-verzendbalk ---------- */
  function paintShipping(cart) {
    document.querySelectorAll('[data-pip-ship]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 10000;
      var total = cart.total_price || 0;
      var rest = Math.max(0, threshold - total);
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      bar.classList.toggle('free-shipping-bar--success', rest === 0);
      var msg = bar.querySelector('[data-pip-ship-msg]');
      if (msg) {
        msg.innerHTML = rest > 0
          ? 'Nog <span class="fs-body-bold">' + money(rest) + '</span> tot gratis verzending'
          : 'Je hebt <span class="fs-body-bold">gratis verzending</span>!';
      }
      var prog = bar.querySelector('[data-pip-ship-progress]');
      if (prog) prog.style.setProperty('--progress-width', pct + '%');
    });
  }

  var shipTimer = null;
  function refreshShipping() {
    if (!document.querySelector('[data-pip-ship]')) return;
    clearTimeout(shipTimer);
    shipTimer = setTimeout(function () {
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paintShipping)
        .catch(function () {});
    }, 150);
  }

  /* ---------- Videotegels ---------- */
  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        /* groep 24: tegels met data-pip-autoplay speelden eerst via het autoplay-attribuut ook bij 'minder beweging'; dat blijft zo */
        if (entry.isIntersecting && (!reduceMotion || video.hasAttribute('data-pip-autoplay'))) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.4 });
  }

  /* Fase 2, groep 24 (05-10-2026, snelheid): videotegels met preload="none" (snippets/pip-col-video-v2.liquid) alvast laden
     zodra ze binnen 800 px van het scherm komen, zodat ze al spelen als ze in beeld schuiven (zoals eerst met autoplay). */
  var nearObserver = null;
  if ('IntersectionObserver' in window) {
    nearObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var video = entry.target;
        nearObserver.unobserve(video);
        if (video.getAttribute('preload') === 'none') {
          video.setAttribute('preload', 'auto');
          try { video.load(); } catch (e) {}
        }
      });
    }, { rootMargin: '800px 0px' });
  }

  function initVideos() {
    document.querySelectorAll('.pip-gv__video').forEach(function (video) {
      if (video.getAttribute('data-pip-ready')) return;
      video.setAttribute('data-pip-ready', '1');
      video.muted = true;
      if (video.hasAttribute('data-pip-autoplay')) {
        if (nearObserver) nearObserver.observe(video);
        else { video.setAttribute('preload', 'auto'); if (!reduceMotion) { var p0 = video.play(); if (p0 && p0.catch) p0.catch(function () {}); } }
      }
      if (observer) observer.observe(video);
    });
  }

  /* ---------- Klikken ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var el = t.closest('[data-pip-size]');
    if (el) {
      state.size = el.getAttribute('data-pip-size');
      setActive('data-pip-size', state.size);
      applyFilters();
      return;
    }
    el = t.closest('[data-pip-type]');
    if (el) {
      e.preventDefault();
      state.type = el.getAttribute('data-pip-type');
      setActive('data-pip-type', state.type);
      applyFilters();
      return;
    }
    el = t.closest('[data-pip-qa-open]');
    if (el) {
      e.preventDefault();
      var scope = el.closest('[data-pip-qa]');
      if (scope) {
        if (scope.classList.contains('is-open')) closePanel(scope);
        else openPanel(scope);
      }
      return;
    }
    el = t.closest('[data-pip-qa-close]');
    if (el) {
      e.preventDefault();
      closePanel(el.closest('[data-pip-qa]'));
      return;
    }
    el = t.closest('[data-pip-add]');
    if (el) {
      e.preventDefault();
      addToCart(el);
      return;
    }
    el = t.closest('[data-pip-mute]');
    if (el) {
      e.preventDefault();
      var card = el.closest('[data-pip-video-card]');
      var video = card && card.querySelector('video');
      if (video) {
        video.muted = !video.muted;
        el.classList.toggle('is-unmuted', !video.muted);
        if (!video.muted) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-pip-qa].is-open').forEach(closePanel);
    }
  });

  /* ---------- Start ---------- */
  function init() {
    setActive('data-pip-size', state.size);
    setActive('data-pip-type', state.type);
    applyFilters();
    initVideos();
  }
  init();

  var grid = document.getElementById('ProductGridContainer');
  if (grid && 'MutationObserver' in window) {
    new MutationObserver(function () {
      applyFilters();
      initVideos();
    }).observe(grid, { childList: true, subtree: true });
  }

  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && 'MutationObserver' in window) {
    new MutationObserver(refreshShipping).observe(bubble, { childList: true, subtree: true, characterData: true });
  }
  if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, refreshShipping);
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshShipping();
  });
})();